import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { LocalizeParser, LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { BaseComponent } from 'src/shared/abstracts/base.abstract';

@Component({
    selector: 'app-lang-selector',
    templateUrl: './lang-selector.component.html',
    styleUrls: ['./lang-selector.component.scss'],
})
export class LangSelectorComponent extends BaseComponent implements OnInit {
    public langs: string[];

    public langForm: FormGroup;

    constructor(private localizeParser: LocalizeParser, private localize: LocalizeRouterService, private fb: FormBuilder) {
        super();
    }

    ngOnInit(): void {
        this.langs = this.localizeParser.locales;
        this.langForm = this.fb.group({
            lang: ['fr'],
        });
        this.uns = this.lang.valueChanges.subscribe((value: string) => this.changeLang(value));
    }

    public changeLang(lang: string): void {
        this.localize.changeLanguage(lang);
    }

    public get lang(): FormControl {
        return this.langForm.get('lang') as FormControl;
    }
}
